import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { newSearch } from '@/results/store/actions'

import { loadSimilarJobs, loadSimilarJobsFailure, loadSimilarJobsSuccess } from './actions'
import { defaultJobsResults, defaultParams, defaultSelectedJobId, defaultSourceJobId } from './defaultState'

/**
 * @private exported only for tests
 */
export const params = handleActions({
  [newSearch.request]: () => defaultParams
}, defaultParams)

/**
 * @private exported only for tests
 */
export const sourceJobId = handleActions({
  [newSearch.request]: () => defaultSourceJobId
}, defaultSourceJobId)

/**
 * @private exported only for tests
 */
export const selectedJobId = handleActions({
  [newSearch.request]: () => defaultSelectedJobId
}, defaultSelectedJobId)

/**
 * @private exported only for tests
 */
export const jobsResults = handleActions({
  [loadSimilarJobs]: (state) => ({ ...state, loading: true }),
  [loadSimilarJobsSuccess]: (state, { payload: { result, resultSize } }) => ({
    items: [...state.items, ...result],
    totalCount: resultSize,
    loading: false
  }),
  [loadSimilarJobsFailure]: (state) => ({ ...state, loading: false }),
  [newSearch.request]: () => defaultJobsResults
}, defaultJobsResults)

export default combineReducers({
  params,
  selectedJobId,
  sourceJobId,
  jobsResults
})
